import { useDispatchTrackEvent, useTealiumEventProperties } from "@grandvisionhq/svc-tealium/events";
const useNewsletterSubmit = (subscribeNewsletter) => {
  const dispatchTrackEvent = useDispatchTrackEvent();
  const { getCommonUserProperties } = useTealiumEventProperties();
  const handleNewsletterSignupSuccessTealium = async () => {
    try {
      const commonUserProperties = await getCommonUserProperties();
      dispatchTrackEvent(
        () => Promise.resolve({
          id: "Event",
          Events_UserEmailSub: "1",
          ...commonUserProperties
        })
      );
    } catch (error) {
      console.error("Failed to hash email:", error);
    }
  };
  const onSubmit = async ({ email, firstName, lastName, mandateText }) => {
    try {
      const { data } = await subscribeNewsletter({
        variables: {
          input: {
            email,
            firstName,
            lastName,
            mandateText,
            uiType: "checkbox",
            value: true
          }
        }
      });
      if (data?.subscribeNewsletter.success) {
        handleNewsletterSignupSuccessTealium();
      }
    } catch (error) {
      console.error("Newsletter subscription failed:", error);
    }
  };
  return { onSubmit };
};
export {
  useNewsletterSubmit
};
//# sourceMappingURL=use-newsletter-submit.js.map
